import { classEnum } from "./base";

export const TaxTypeEnum = new (class extends classEnum([
    {
        label: "PPN",
        value: "ppn",
    },
    {
        label: "Tidak Ada",
        value: "none",
    },
]) {
    public get valuesAllowed() {
        return this.values.filter((v) => v !== "none");
    }

    public get selectAllowed() {
        return this.select.filter((v) => v.value !== "none");
    }

    public get ValuesAllowed(): this["valuesAllowed"][number] {
        throw new Error("ValuesAllowed can't be used as a value");
    }
})();

export namespace TaxTypeEnum {
    export type Labels = (typeof TaxTypeEnum)["labels"][number];
    export type Values = (typeof TaxTypeEnum)["values"][number];
    export type ValuesAllowed = (typeof TaxTypeEnum)["valuesAllowed"][number];
}
